var n=function(){return JSON.parse('{"tag": 0, "transaction":null, "transactionId":null, "encodedData":null, "events": null, "account": null}')};export{n as response};
//# sourceMappingURL=response.module.js.map
